// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-tile[data-v-3a22b684]{display:flex;justify-content:center;align-items:center;flex-direction:column;cursor:pointer;border-radius:6px;background-color:var(--v-background-base);transition:transform .2s}.app-tile[data-v-3a22b684]:hover{transform:scale(1.1)}", ""]);
// Exports
module.exports = exports;
